"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, use } from "react";
import { TrackPageViewContainer } from "@/components/Tracking/TrackPageViewContainer.component";
import type { TrackingDataModel } from "@/hooks/tracking/models/tracking-data-model.types";
import { InitializeBloomreach } from "@/vendors/Bloomreach/components/InitializeBloomreach";
import { InitializeGemius } from "@/vendors/Gemius/InitializeGemius.component";
import { InitializeLinkedInInsightTag } from "@/vendors/LinkedIn/InitializeLinkedInInsightTag";
const TrackingContext = createContext<TrackingDataModel | undefined>(undefined);
type TrackingProviderProps = {
  readonly model: TrackingDataModel;
  readonly children: ReactNode;
};
type UseTrackingContextReturn = {
  readonly trackingData: null | TrackingDataModel;
};
export function useTrackingData(): UseTrackingContextReturn {
  const trackingData = use(TrackingContext) ?? null;
  return {
    trackingData
  };
}
export function TrackingProvider(t0) {
  const $ = _c(11);
  const {
    children,
    model
  } = t0;
  let t1;
  if ($[0] !== model) {
    t1 = <InitializeBloomreach trackingData={model} />;
    $[0] = model;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InitializeGemius />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== model) {
    t3 = model.linkedinInsightId !== null ? <InitializeLinkedInInsightTag trackingData={model} /> : null;
    $[3] = model;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TrackPageViewContainer />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== model || $[8] !== t1 || $[9] !== t3) {
    t5 = <TrackingContext value={model}>{t1}{t2}{t3}{t4}{children}</TrackingContext>;
    $[6] = children;
    $[7] = model;
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}